import type { PropagationInfo } from '../../types/careExpanded';

interface PropagationSectionProps {
  propagation: PropagationInfo;
}

export function PropagationSection({ propagation }: PropagationSectionProps) {
  if (propagation.methods.length === 0) {
    return (
      <p className="text-sm text-gray-500 italic">No propagation methods available</p>
    );
  }

  return (
    <div className="space-y-4">
      {propagation.methods.map((method, index) => (
        <div
          key={index}
          className="p-4 rounded-lg bg-background border border-gray-200"
        >
          {/* Method name */}
          <h4 className="font-medium text-editorial-black mb-3 flex items-center gap-2">
            <span className="text-primary" aria-hidden="true">🌱</span>
            {method.name}
          </h4>

          {/* Steps list */}
          <ol className="space-y-2 mb-3">
            {method.steps.map((step, i) => (
              <li key={i} className="flex items-start gap-3 text-sm text-editorial-black">
                <span className="flex-shrink-0 flex items-center justify-center h-5 w-5 rounded-full bg-primary/10 text-primary text-xs font-medium">
                  {i + 1}
                </span>
                <span className="pt-0.5">{step}</span>
              </li>
            ))}
          </ol>

          {/* Success tips */}
          {method.successTips && (
            <div className="mt-3 pt-3 border-t border-gray-100">
              <p className="text-xs text-gray-500">
                <span className="font-medium text-green-600">Tip:</span> {method.successTips}
              </p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
